import { useState } from "react";
import { NotebookPen, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Hint } from "@/components/Hint";

// Quick manual entry into the Decision Journal; the server freezes an indicator snapshot with it.
export const CoinNote = ({ coin, price }) => {
  const [note, setNote] = useState(""); const [busy, setBusy] = useState(false); const [last, setLast] = useState(null);
  const save = async () => {
    if (!note.trim()) return;
    setBusy(true);
    try {
      const r = await api.post("/journal", { coin_id: coin.id, symbol: coin.symbol, name: coin.name, note: note.trim(), price: price || undefined });
      setLast(r.data); setNote("");
      toast.success("Logged to your Decision Journal");
    } catch (e) { toast.error(apiError(e, "Could not save note")); }
    setBusy(false);
  };
  return (
    <div className="apx-card p-4" data-testid="coin-note-card">
      <div className="flex items-center gap-2 mb-2">
        <Hint title="Decision Journal" text="Write down why you are acting (or waiting). EV-IDEX stores the note together with the price, RSI, MACD, moving averages and the latest AI outlook at that moment so you can review your reasoning later." asChild>
          <span className="text-[10px] font-mono-ticker uppercase tracking-widest text-slate-400 inline-flex items-center gap-1 cursor-help"><NotebookPen className="w-3 h-3 text-cyan-300" /> Decision journal</span>
        </Hint>
        <Link to="/journal" className="ml-auto text-[10px] text-cyan-300 hover:underline" data-testid="coin-note-open-journal">Open journal →</Link>
      </div>
      <div className="flex gap-2">
        <input data-testid="coin-note-input" value={note} onChange={(e) => setNote(e.target.value)} maxLength={600}
          onKeyDown={(e) => { if (e.key === "Enter") save(); }}
          placeholder="Why are you buying, selling or waiting right now?"
          className="flex-1 apx-ring px-3 py-2 rounded-lg bg-slate-900 border border-slate-800 outline-none text-xs" />
        <button data-testid="coin-note-save" disabled={busy || !note.trim()} onClick={save} className="btn-primary rounded-lg px-3 py-2 text-xs disabled:opacity-50">
          {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : "Log"}
        </button>
      </div>
      {last && <div className="mt-2 text-[10px] text-slate-500" data-testid="coin-note-saved">Saved with snapshot: RSI {last.snapshot?.rsi?.toFixed?.(1) ?? "—"} · MACD hist {last.snapshot?.macd_hist?.toFixed?.(3) ?? "—"} · AI {last.snapshot?.ai_outlook ?? "—"}</div>}
    </div>
  );
};
